import { render, staticRenderFns } from "./lyluckydrawlist.vue?vue&type=template&id=0ed2c0f4&"
import script from "./lyluckydrawlist.vue?vue&type=script&lang=js&"
export * from "./lyluckydrawlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports